import React, {useCallback, useEffect, useMemo, useState} from 'react';
import classnames from 'classnames';
import { Translator } from 'Translator';
import { SearchMode } from 'model/Filters';

const CSS = require('./LocalsOrExperiencesSelector.less');

const modes = [SearchMode.ALL, SearchMode.LOCALS, SearchMode.EXPERIENCES];

function LocalsOrExperiencesSelector({ mode, onChange }) {
  const searchUrlParams = useMemo(() => {
    return new URLSearchParams(window.location.search);
  }, []);

  const [selected, setSelected] = useState(mode);
  const onButtonClick = useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();
    setSelected(event.target.name);
    onChange(event.target.name);
  }, [onChange]);

  useEffect(() => {
    if (searchUrlParams.has('type')) {
      const type = searchUrlParams.get('type');
      switch (type) {
        case 'locals':
          setSelected(SearchMode.LOCALS);
          onChange(SearchMode.LOCALS);
          break;
        case 'experiences':
          setSelected(SearchMode.EXPERIENCES);
          onChange(SearchMode.EXPERIENCES);
          break;
        case 'all':
          setSelected(SearchMode.ALL);
          onChange(SearchMode.ALL);
      }
    }
  }, [searchUrlParams, setSelected, onChange]);


  return (
    <div className={CSS.LocalsOrExperiencesSelector}>
      <h3 className={CSS.Title}>
        {Translator.translate('UserEnvironment.LocationFilter.exploreWithlocals', {}, true, 'Explore Withlocals')}
      </h3>
      <div className={CSS.ButtonsGroup}>
        {
          modes.map(mode => (
            <button
              name={mode}
              key={mode}
              className={classnames(CSS.ToggleButton, { [CSS.Toggled]: selected === mode })}
              onClick={onButtonClick}
            >
              {Translator.translateText(`UserEnvironment.LocationFilter.${mode}`, {}, mode)}
            </button>
          ))
        }
      </div>
    </div>
  );
}

export default LocalsOrExperiencesSelector;
